window.dataLayer = window.dataLayer || [];
function gtag() {
  window.dataLayer.push(arguments);
}
gtag("js", new Date());
gtag("config", "AW-16586188386");
console.log(gtag,gtag("js", new Date()),'00000000000000');
function gtag_report_conversion(url) {
  var callback = function () {
    if (typeof url != "undefined") {
      window.location = url;
    }
  };
  gtag("event", "conversion", {
    send_to: "AW-16586188386/meB6COGOy8YZEOLM9OQ9",
    event_callback: callback,
  });
  return false;
}

function gtag_report_conversion_phone(url) {
  var callback = function () {
    if (typeof url != "undefined") {
      window.location = url;
    }
  };
  gtag("event", "conversion", {
    send_to: "AW-16586188386/a-Q8COSOy8YZEOLM9OQ9",
    event_callback: callback,
  });
  return false;
}
export { gtag_report_conversion, gtag_report_conversion_phone };
// 然后在移动端页面上用户电话点击的时候，绑定一个onclick事件，在onclick事件上触发上面的gtag_report_conversion_phone()方法就可以了

// 这个也是加入到head中

// 上面的三段代码，都包含js脚步，js脚步都加入网站移动端head标签中

// 第二个js脚步和第三个js脚步中定义了两个方法，第一个方法gtag_report_conversion()方法,在表单提交的时候绑定，第二个方法是gtag_report_conversion_phone()，在电话点击的时候绑定
